exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bc-item {\n    margin-right: 10px;\n    padding: 5px;\n    border: 1px solid;\n    background-color:  white;\n}\n\n", ""]);

// exports
